import { Service } from "../../interfaces";

const BASE_APP_URL_v1 = process.env.REACT_APP_BASE_URL_v1;

export const ApiUrls = {
  authModule: {
    login: `${BASE_APP_URL_v1}auth/login/`,
    refresh: `${BASE_APP_URL_v1}auth/refresh/`, // ENDPOINT WILL BE UPDATED
    logout: `${BASE_APP_URL_v1}auth/logout`,
    forgotPassword: `${BASE_APP_URL_v1}auth/forgot-password/`,
    resendOTP: `${BASE_APP_URL_v1}auth/resend-otp/`,
    resetPassword: `${BASE_APP_URL_v1}auth/reset-password/`,
    acceptTerms: `${BASE_APP_URL_v1}users/me/accept-terms-eula/`,
  },
  admin: {
    invite: `${BASE_APP_URL_v1}auth/admin/invite/`,
    setUpAccount: `${BASE_APP_URL_v1}auth/admin/account-setup/`,
    userInvite: `${BASE_APP_URL_v1}auth/invite/`,
    reInviteRegionalAdmin: `${BASE_APP_URL_v1}auth/admin/invite/resend/`,
    createGlobalAdmin: `${BASE_APP_URL_v1}add-global-admin/`,
  },
  company: {
    list: `${BASE_APP_URL_v1}company/`,
    onboardingStats: `${BASE_APP_URL_v1}company/onboarding-stats/`,
    pendingTasks: `${BASE_APP_URL_v1}company/pending-tasks/`,
    services: `${BASE_APP_URL_v1}company/services/`,
    activate: (id: string) => `${BASE_APP_URL_v1}company/${id}/activate/`,
    coa: (id: string) => `${BASE_APP_URL_v1}company/${id}/coa/`,
    coaUpload: (id: string) => `${BASE_APP_URL_v1}company/${id}/coa/upload/`,
    coaTallyPreview: (id: string) =>
      `${BASE_APP_URL_v1}company/${id}/coa/import-tally-xml/preview/`,
    coaTallyImport: (id: string) =>
      `${BASE_APP_URL_v1}company/${id}/coa/import-tally-xml/`,
    coaVersions: (id: string) => `${BASE_APP_URL_v1}company/${id}/coa/versions/`,
    coaRestoreVersion: (id: string, version: number) =>
      `${BASE_APP_URL_v1}company/${id}/coa/versions/${version}/restore/`,
    coaReallocate: (id: string) =>
      `${BASE_APP_URL_v1}company/${id}/coa/reallocate/`,
    coaExport: (id: string) => `${BASE_APP_URL_v1}company/${id}/coa/export/`,
    // Tally auto-sync
    syncToken: (id: string) => `${BASE_APP_URL_v1}company/${id}/sync-token/`,
    tallyPendingConflict: (id: string) =>
      `${BASE_APP_URL_v1}company/${id}/tally-sync/pending-conflict/`,
    tallyResolve: (id: string) =>
      `${BASE_APP_URL_v1}company/${id}/tally-sync/resolve/`,
    tallyDismissMismatch: (id: string) =>
      `${BASE_APP_URL_v1}company/${id}/tally-sync/dismiss-mismatch/`,
    tallyDismissCoaMismatch: (id: string) =>
      `${BASE_APP_URL_v1}company/${id}/tally-sync/dismiss-coa-mismatch/`,
    tallyAddMissingCoaAccounts: (id: string) =>
      `${BASE_APP_URL_v1}company/${id}/tally-sync/add-missing-coa-accounts/`,
  },
  improvementsAndFixes: {
    list: `${BASE_APP_URL_v1}improvements-and-fixes/`,
    detail: (id: string) => `${BASE_APP_URL_v1}improvements-and-fixes/${id}/`,
  },
  glGroupSelections: {
    detail: (widgetKey: string) =>
      `${BASE_APP_URL_v1}gl-group-selections/${widgetKey}/`,
  },
  dashboardNotes: {
    detail: `${BASE_APP_URL_v1}dashboard-notes/`,
  },
  glMapping: {
    detail: (companyId: string) => `${BASE_APP_URL_v1}gl-mapping/${companyId}/`,
    classes: `${BASE_APP_URL_v1}gl-mapping/classes/`,
    unmappedSummary: `${BASE_APP_URL_v1}gl-mapping/unmapped-summary/`,
    mlOpsSummary: `${BASE_APP_URL_v1}gl-mapping/ml-ops-summary/`,
  },
  tagMapping: {
    detail: `${BASE_APP_URL_v1}tag-mapping/`,
    account: (accountId: string) =>
      `${BASE_APP_URL_v1}tag-mapping/${accountId}/`,
    suggestions: (accountId: string) =>
      `${BASE_APP_URL_v1}tag-mapping/${accountId}/suggestions/`,
    suggestionsReject: (accountId: string) =>
      `${BASE_APP_URL_v1}tag-mapping/${accountId}/suggestions/reject/`,
  },
  modelTraining: {
    preview: (accountId: string) =>
      `${BASE_APP_URL_v1}machine-learning/train/${accountId}/preview/`,
    train: (accountId: string) =>
      `${BASE_APP_URL_v1}machine-learning/train/${accountId}/`,
    status: (accountId: string) =>
      `${BASE_APP_URL_v1}machine-learning/train/${accountId}/status/`,
    eligibleSummary: () =>
      `${BASE_APP_URL_v1}machine-learning/train/eligible-summary/`,
  },
  maskingRules: {
    list: `${BASE_APP_URL_v1}masking-rules/`,
    glGroup: `${BASE_APP_URL_v1}masking-rules/gl-group/`,
    term: `${BASE_APP_URL_v1}masking-rules/term/`,
    narrationKeyword: `${BASE_APP_URL_v1}masking-rules/narration-keyword/`,
    detail: (id: string) => `${BASE_APP_URL_v1}masking-rules/${id}/`,
  },
  platformTelemetry: {
    detail: `${BASE_APP_URL_v1}platform-telemetry/`,
  },
  backupStatus: {
    detail: `${BASE_APP_URL_v1}backup-status/`,
  },
  auditLog: {
    list: `${BASE_APP_URL_v1}audit-log/`,
  },
  privacyRequests: {
    create: `${BASE_APP_URL_v1}privacy-requests/`,
    mine: `${BASE_APP_URL_v1}privacy-requests/mine/`,
    list: `${BASE_APP_URL_v1}privacy-requests/`,
    update: (id: string) => `${BASE_APP_URL_v1}privacy-requests/${id}/`,
    emailVisibility: `${BASE_APP_URL_v1}privacy-requests/email-visibility/`,
  },
  users: {
    me: `${BASE_APP_URL_v1}users/me/`,
    users: `${BASE_APP_URL_v1}users/`,
    onboardingStats: `${BASE_APP_URL_v1}users/onboarding-stats/`,
    reAssignCompanies: (id: string) =>
      `${BASE_APP_URL_v1}users/${id}/re-assign-companies/`,
    changeRole: (id: string) => `${BASE_APP_URL_v1}users/${id}/change-role/`,
  },
  records: {
    upload: `${BASE_APP_URL_v1}records/`,
    allocateGL: `${BASE_APP_URL_v1}records/allocate/`,
    filters: `${BASE_APP_URL_v1}records/filters/`,
    glDumpFiles: `${BASE_APP_URL_v1}records/gl-dump-files/`,
    comments: (service: Service) => `${BASE_APP_URL_v1}comments/${service}/`,
    export: `${BASE_APP_URL_v1}records/export/`,
    closingBalanceSum: `${BASE_APP_URL_v1}records/closing-balance-sum/`,
    rerunGLGroup: `${BASE_APP_URL_v1}records/rerun-gl-group/`,
    glGroups: `${BASE_APP_URL_v1}records/gl-groups/`,
    glGroupBalances: `${BASE_APP_URL_v1}records/gl-group-balances/`,
    cashFlow: `${BASE_APP_URL_v1}records/cash-flow/`,
    incomeExpenseMonthly: `${BASE_APP_URL_v1}records/income-expense-monthly/`,
  },
  reports: {
    stats: (service: Service) => `${BASE_APP_URL_v1}reports/${service}/stats/`,
    chartsData: (service: Service) =>
      `${BASE_APP_URL_v1}reports/${service}/chart-data/`,
    yearlyStats: (service: Service) =>
      `${BASE_APP_URL_v1}reports/${service}/yearly/`,
    ratio: (service: Service) => `${BASE_APP_URL_v1}reports/${service}/ratio/`,
    reportDetails: `${BASE_APP_URL_v1}reports/`,
  },
  tags: {
    list: `${BASE_APP_URL_v1}tags/`,
  },
  xplain: {
    reportComparison: `${BASE_APP_URL_v1}xplain/`,
    aiWork: `${BASE_APP_URL_v1}xplain/get-ai-work/`,
    momVariance: `${BASE_APP_URL_v1}xplain/mom-variance/`,
    glGroupTagSummary: `${BASE_APP_URL_v1}xplain/gl-group-tag-summary/`,
  },
  dimeai: {
    chat: `${BASE_APP_URL_v1}dime-ai/chat/`,
    stopChat: `${BASE_APP_URL_v1}dime-ai/chat/stop/`,
    suggestedQuestions: `${BASE_APP_URL_v1}ai-advisor/suggested-questions/`,
    feedback: `${BASE_APP_URL_v1}dime-ai/chat/feedback/`,
    thumbsDownFeedback: `${BASE_APP_URL_v1}dime-ai/feedback/thumbs-down/`,
    usageStats: `${BASE_APP_URL_v1}dime-ai/usage-stats/`,
    threads: `${BASE_APP_URL_v1}ai-advisor/threads/`,
    guardrails: `${BASE_APP_URL_v1}ai-advisor/guardrails/`,
    guardrailTest: `${BASE_APP_URL_v1}ai-advisor/guardrails/test/`,
    terminologySynonyms: `${BASE_APP_URL_v1}ai-advisor/terminology-synonyms/`,
    antiSynonyms: `${BASE_APP_URL_v1}ai-advisor/anti-synonyms/`,
    abbreviations: `${BASE_APP_URL_v1}ai-advisor/abbreviations/`,
    voucherTypes: `${BASE_APP_URL_v1}ai-advisor/voucher-types/`,
    ratioFormulas: `${BASE_APP_URL_v1}ai-advisor/ratio-formulas/`,
    tokenUsage: `${BASE_APP_URL_v1}ai-advisor/usage/`,
    usageSummary: `${BASE_APP_URL_v1}ai-advisor/usage/summary/`,
    usageTelemetry: `${BASE_APP_URL_v1}ai-advisor/usage/telemetry/`,
    newThreadDocument: `${BASE_APP_URL_v1}ai-advisor/documents/`,
    threadDocuments: (threadId: string) =>
      `${BASE_APP_URL_v1}ai-advisor/threads/${threadId}/documents/`,
    // Standalone router (prefix "/tag-independent-periods", NOT nested under
    // "ai-advisor/" like the rest of this block) -- mirrors the backend
    // router's own declared prefix exactly, same convention as every other
    // key here.
    tagIndependentPeriods: `${BASE_APP_URL_v1}tag-independent-periods/`,
  },
  alerts: {
    list: `${BASE_APP_URL_v1}alerts/`,
    readAll: `${BASE_APP_URL_v1}alerts/read-all/`,
  },
};
